import React from 'react';
import { Container } from 'reactstrap';
import RolePermissionView from './Components/RolePermissionView';

const RolePermission = () => {
  document.title = 'Role Permission';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid className='px-0'>
          <RolePermissionView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RolePermission;
